var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerSoda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.2857C2 15.425 2.67638 14.7273 3.51073 14.7273H15.5965C16.4309 14.7273 17.1073 15.425 17.1073 16.2857C17.1073 17.1464 16.4309 17.8442 15.5965 17.8442H3.51073C2.67638 17.8442 2 17.1464 2 16.2857Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6015 3.73604C18.6357 3.62998 18.732 3.55844 18.8403 3.55844H21.1359C21.5531 3.55844 21.8912 3.20957 21.8912 2.77922C21.8912 2.34887 21.5531 2 21.1359 2H18.8403C18.0817 2 17.4082 2.50078 17.1683 3.24322L16.1432 6.41558H12.2147C11.6056 6.41558 11.1359 6.96902 11.2164 7.59186L11.4014 9.02339C13.829 9.1737 15.8351 10.9368 16.4265 13.2879C17.6917 13.6599 18.618 14.8612 18.618 16.2857C18.618 17.7102 17.6917 18.9115 16.4265 19.2835C16.1612 20.3382 15.6112 21.2745 14.8663 22H19.247C19.7517 22 20.1786 21.6145 20.2453 21.0984L21.991 7.59186C22.0715 6.96902 21.6018 6.41558 20.9927 6.41558H17.7356L18.6015 3.73604Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8001 13.1688C14.2675 11.8114 13.0597 10.8103 11.6063 10.6087C11.4291 10.5841 11.2482 10.5714 11.0644 10.5714H8.0429C6.35221 10.5714 4.90476 11.6458 4.30713 13.1688H14.8001Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30713 19.4026C4.90476 20.9256 6.35221 22 8.0429 22H11.0644C11.795 22 12.4801 21.7994 13.0709 21.4486C13.8473 20.9877 14.4608 20.2675 14.8001 19.4026H4.30713Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerSoda);
export default __webpack_public_path__ + "static/media/burger-soda.41d4459b4363cf8a085624da6a2fb72a.svg";
export { ForwardRef as ReactComponent };